var map = {
	"./Central-mobile.jpg": 1502,
	"./Mandurah-mobile.jpg": 1503,
	"./North-mobile.jpg": 1504,
	"./South-mobile.jpg": 1505,
	"./default-mobile.jpg": 1506
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1501;